module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/no-access/no-access.component.css
// module id = ./src/app/components/no-access/no-access.component.css
// module chunks = main